module.exports = __webpack_public_path__ + "img/Wood Burning Fireplace.2a17fba4.jpg";